var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLockFill = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8571 12.625H20.7857V9.53125C20.7857 5.93047 17.7411 3 14 3C10.2589 3 7.21429 5.93047 7.21429 9.53125V12.625H6.14286C4.95982 12.625 4 13.5488 4 14.6875V22.9375C4 24.0762 4.95982 25 6.14286 25H21.8571C23.0402 25 24 24.0762 24 22.9375V14.6875C24 13.5488 23.0402 12.625 21.8571 12.625ZM17.2143 12.625H10.7857V9.53125C10.7857 7.82539 12.2277 6.4375 14 6.4375C15.7723 6.4375 17.2143 7.82539 17.2143 9.53125V12.625Z",
    fill: "#111111"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLockFill, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/lock-fill.aa18af13.svg";
export { ForwardRef as ReactComponent };